import { NgModule } from '@angular/core';
import { DsLibSnackbarComponent } from './ds-lib-snackbar.component';
import { DsLibSharedModule } from '../../../../shared/ds-lib-shared.module';
import { DsLibMaterialModule } from '../../../../shared/ds-lib-material.module';
import { DsLibSnackbar } from './services/ds-lib-snackbar.service';

const components = [DsLibSnackbarComponent];

@NgModule({
  declarations: components,
  imports: [DsLibSharedModule, DsLibMaterialModule],
  exports: components,
  providers: [DsLibSnackbar],
})
export class DsLibSnackbarModule {}
